
// import Animations from '../modules/animations';
// import { slick } from 'slick-carousel';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

export default {

  init() {

    // Animations.init();
    jQuery(document).ready(function ($) {
      $('#load-more').on('click', function () {
        var button = $(this);
        var page = parseInt(button.data('page')) + 1;
        var max = parseInt(button.data('max'));

        $.ajax({
          url: ajaxurl, // WordPress global
          type: 'POST',
          data: {
            action: 'load_more_posts',
            paged: page
          },
          beforeSend: function () {
            button.text('Loading...');
          },
          success: function (res) {
            $('#ajax-posts').append(res);
            button.data('page', page);

            if (page >= max) {
              button.remove();
            } else {
              button.text('Load More');
            }
          }
        });
      });
    });

  },
  finalize() { }
}